// First Layer of reinsurance mutation

import {
  RI_LOADING,
  RI_SUCCESS,
  RI_FAIL,
  RI_LISTING_LOADING,
  RI_LISTING_SUCCESS,
  RI_LISTING_FAIL,
  RI_DETAIL_LOAD_DATA,
  RI_AUTOCESSION_INIT_LOADING,
  RI_AUTOCESSION_INIT_SUCCESS,
  RI_AUTOCESSION_INIT_FAIL
} from '@/store/types'
import { formatDisplayDate } from '@/utils/date'

export const general = {
  [RI_LOADING](state) {
    state.init = 0
    state.initErr = []
    state.menu = {}
  },
  [RI_SUCCESS](state, data) {
    state.init = 1
    state.initErr = []
    state.menu = data.menu
  },
  [RI_FAIL](state, error) {
    state.init = 2
    state.initErr = error
    state.menu = {}
  },
  [RI_LISTING_LOADING](state) {
    state.riOutListing.init = 0
    state.riOutListing.initErr = []
    state.riOutListing.menu = {}
  },
  [RI_LISTING_SUCCESS](state, data) {
    state.riOutListing.init = 1
    state.riOutListing.initErr = []
    state.riOutListing.menu = data.menu
  },
  [RI_LISTING_FAIL](state, error) {
    state.riOutListing.init = 2
    state.riOutListing.initErr = error
    state.riOutListing.menu = {}
  },
  [RI_DETAIL_LOAD_DATA] (state, fullData) {
    const { data } = fullData
    commitPolMaster(state, data)
  },
  [RI_AUTOCESSION_INIT_LOADING](state) {
    state.riAutoCession.init = 0
    state.riAutoCession.initErr = []
    state.riAutoCession.menu = {}
  },
  [RI_AUTOCESSION_INIT_SUCCESS](state, data) {
    state.riAutoCession.init = 1
    state.riAutoCession.initErr = []
    state.riAutoCession.menu = data.menu
  },
  [RI_AUTOCESSION_INIT_FAIL](state, error) {
    state.riAutoCession.init = 2
    state.riAutoCession.initErr = error
    state.riAutoCession.menu = {}
  }
}

const commitPolMaster = (state, data) => {
  state.riDetailListing.riDetail = {
    polNo: data.polNo,
    renCnt: data.renCnt,
    endtCnt: data.endtCnt,
    polType: data.polType,
    polTypeDesc: data.polTypeDesc,
    comDate: formatDisplayDate(data.comDate),
    expDate: formatDisplayDate(data.expDate),
    branchDesc: data.branchDesc,
    fundDesc: data.fund,
    uwYr: data.uwYr,
    insdName1: data.insdName1,
    billCurr: data.billCurr,
    billCurrRate: data.billCurrRate,
    tranRel: data.tranRel,
    // OS-411: Added 5-Oct-2020
    polStatDesc: data.polStatDesc,
    name: data.name,
    ctyDesc: data.ctyDesc,
    fundDescription: data.fundDesc,
    deptDesc: data.deptDesc,
    busSrcDesc: data.busSrcDesc,
    paytMethDesc: data.paytMethDesc,
    finInstName: data.finInstName,
    armName: data.armName,
    createdName: data.createdName,
    modifiedName: data.modifiedName,
    cedAntName: data.cedAntName,
    acctNoSfxDesc: data.acctNoSfxDesc,
    schemeDesc: data.schemeDesc,
    polStat: data.polStat,
    acctNo1: data.acctNo1,
    insdRefNo: data.insdRefNo,
    insdName2: data.insdName2,
    insdName3: data.insdName3,
    maintPer: data.maintPer,
    dliabPer: data.dliabPer,
    endtDate: data.endtDate,
    tranDate: data.tranDate,
    acceptDate: data.acceptDate,
    firstIssDate: data.firstIssDate,
    dri: data.dri,
    cty: data.cty,
    fund: data.fund,
    branch: data.branch,
    dept: data.dept,
    busSrc: data.busSrc,
    scheme: data.scheme,
    prevPolNo: data.prevPolNo,
    renPolNo: data.renPolNo,
    cnNo: data.cnNo,
    cnDate: data.cnDate,
    ipcNo: data.ipcNo,
    ipcSeqNo: data.ipcSeqNo,
    ipcStatus: data.ipcStatus,
    ipcDate: data.ipcDate,
    totNoInstal: data.totNoInstal,
    paytMeth: data.paytMeth,
    finInst: data.finInst,
    cpCode: data.cpCode,
    batchRel: data.batchRel,
    entRilater: data.entRilater,
    createdBy: data.createdBy,
    createdDate: data.createdDate,
    modifiedBy: data.modifiedBy,
    modifiedDate: data.modifiedDate,
    recip: data.recip,
    cedAnt: data.cedAnt,
    cedAcctNoSfx: data.cedAcctNoSfx,
    cedPolNo: data.cedPolNo,
    cedCesNo: data.cedCesNo,
    cedSI: data.cedSI,
    ourSharePct: data.ourSharePct,
    ccaDate: data.ccaDate,
    ccdDate: data.ccdDate,
    appCoIns: data.appCoIns,
    billCoIns: data.billCoIns,
    coInsPct: data.coInsPct
  }
}
